/**
 * Goals module UI state — year navigation, create/edit sheet, viewing goal.
 */

import { create } from 'zustand'
import type { Goal } from '@turnifly/shared/types'

interface GoalsState {
  selectedYear: number
  isCreateSheetOpen: boolean
  editingGoal: Goal | null
  viewingGoalId: string | null
  isEntrySheetOpen: boolean
  entryGoalId: string | null

  setSelectedYear: (year: number) => void
  nextYear: () => void
  prevYear: () => void
  openCreate: () => void
  closeCreate: () => void
  setEditingGoal: (goal: Goal | null) => void
  setViewingGoalId: (id: string | null) => void
  openEntrySheet: (goalId: string) => void
  closeEntrySheet: () => void
}

export const useGoalsStore = create<GoalsState>()((set) => ({
  selectedYear: new Date().getFullYear(),
  isCreateSheetOpen: false,
  editingGoal: null,
  viewingGoalId: null,
  isEntrySheetOpen: false,
  entryGoalId: null,

  setSelectedYear: (selectedYear) => set({ selectedYear }),
  nextYear: () => set((s) => ({ selectedYear: s.selectedYear + 1 })),
  prevYear: () => set((s) => ({ selectedYear: s.selectedYear - 1 })),
  openCreate: () => set({ isCreateSheetOpen: true, editingGoal: null }),
  closeCreate: () => set({ isCreateSheetOpen: false, editingGoal: null }),
  setEditingGoal: (editingGoal) =>
    set({ editingGoal, isCreateSheetOpen: !!editingGoal }),
  setViewingGoalId: (viewingGoalId) => set({ viewingGoalId }),
  openEntrySheet: (entryGoalId) => set({ isEntrySheetOpen: true, entryGoalId }),
  closeEntrySheet: () => set({ isEntrySheetOpen: false, entryGoalId: null }),
}))
